/*
  LIORIVE — storewide motion. No dependencies, deferred, ~1 KB.
  1. Section reveal (editorial templates only: home, Conseils, La Maison): each section that starts below
     the first screen rises once into place as it enters the viewport. Sections already on screen are
     never hidden, so nothing flashes; without JS or with reduced motion nothing is ever hidden.
  2. Cart count: a short pop on the header bubble when the cart changes (add, change, remove), so the
     shopper sees where the piece went. Dawn replaces the bubble's markup on every cart change; the new
     node gets the class, so the pop plays once per change and never on page load.
*/
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* 1. Reveal */
  const main = document.querySelector('main[data-lr-motion="editorial"]');
  if (main && 'IntersectionObserver' in window) {
    const fold = window.innerHeight * 0.92;
    const sections = Array.prototype.filter.call(main.children, (s, i) => i > 0 && s.classList.contains('shopify-section') && s.getBoundingClientRect().top > fold);
    if (sections.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('lr-revealed');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      sections.forEach((s) => {
        s.classList.add('lr-reveal');
        io.observe(s);
      });
      /* Content must never depend on the observer alone (throttled frames, embedded views): a passive
         scroll check reveals whatever has reached the viewport, and printing or an anchor jump shows all. */
      const all = () => sections.forEach((s) => s.classList.add('lr-revealed'));
      let queued = false;
      const check = () => {
        queued = false;
        const line = window.innerHeight;
        sections.forEach((s) => { if (s.getBoundingClientRect().top < line) s.classList.add('lr-revealed'); });
      };
      window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(check); } }, { passive: true });
      let idle;
      window.addEventListener('scroll', () => { clearTimeout(idle); idle = setTimeout(check, 200); }, { passive: true });
      window.addEventListener('hashchange', all);
      window.addEventListener('beforeprint', all);
    }
  }

  /* 2. Cart count */
  const icon = document.getElementById('cart-icon-bubble');
  if (icon && 'MutationObserver' in window) {
    new MutationObserver(() => {
      const bubble = icon.querySelector('.cart-count-bubble');
      if (bubble && !bubble.classList.contains('lr-pop')) bubble.classList.add('lr-pop');
    }).observe(icon, { childList: true, subtree: true });
  }
})();
